import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixContextMenu from "@radix-ui/react-context-menu";
export const ContextMenuRadioGroup = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixContextMenu.RadioGroup, {
        className: tailwindMerge("flex flex-col gap-2", className),
        ...restOfProps
    });
};
